import * as React from "react";
import Svg, { Path, G } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={138} height={121} viewBox="0 0 138 121" fill="none" {...props}>
      <Path
        d="M124.557 48.97C118.173 23.87 96.117 5.75 70.226 5.022c-13.688-.384-28.09 4.155-38.577 20.04C12.903 53.46 32.8 73.084 46.673 82.409a86.801 86.801 0 0117.941 16.125c9.37 11.12 27.397 24.937 48.865 3.287 15.56-15.691 15.33-36.13 11.078-52.85z"
        fill="#F2F2F2"
      />
      <Path
        d="M135.473 106.769c0 4.948-23.267 13.726-51.968 13.726-28.701 0-49.244-17.789-49.244-22.737 0-4.947 20.543 4.82 49.244 4.82s51.968-.756 51.968 4.191z"
        fill="#3F3D56"
      />
      <Path
        opacity={0.1}
        d="M135.473 106.769c0 4.948-23.267 13.726-51.968 13.726-28.701 0-49.244-17.789-49.244-22.737 0-4.947 20.543 4.82 49.244 4.82s51.968-.756 51.968 4.191z"
        fill="#000"
      />
      <Path
        d="M135.473 106.717c0 4.947-23.267 8.958-51.968 8.958-28.701 0-49.244-12.969-49.244-17.916 0-4.948 20.543 0 49.244 0s51.968 4.01 51.968 8.958z"
        fill="#3D4456"
      />
      <G opacity={0.7}>
        <Path
          opacity={0.7}
          d="M133.753 31.964c-1.885 3.659-7.86 7.97-11.518 6.085-3.659-1.885-3.617-9.252-1.732-12.91a7.456 7.456 0 0110.038-3.211 7.453 7.453 0 013.212 10.036z"
          fill="#00E417"
        />
        <Path
          opacity={0.7}
          d="M122.544 39.017a1.232 1.232 0 00-1.277-.658l.658-1.277 1.277.658-.658 1.277z"
          fill="#E40046"
        />
        <Path
          opacity={0.7}
          d="M121.613 37.695a1.584 1.584 0 001.282.654"
          stroke="#2F2E41"
          strokeWidth={2}
          strokeMiterlimit={10}
        />
        <Path
          opacity={0.4}
          d="M132.718 27.896c.477-.926.238-1.998-.534-2.396-.771-.397-1.783.031-2.26.957-.477.925-.238 1.998.533 2.395.772.398 1.784-.03 2.261-.956z"
          fill="#fff"
        />
        <Path
          opacity={0.7}
          d="M122.2 38.095l-5.559 13.99"
          stroke="#2F2E41"
          strokeWidth={2}
          strokeMiterlimit={10}
        />
      </G>
      <Path
        d="M134.927 54.408c-4.127 4.163-14.089 7.463-18.253 3.336-4.163-4.127-.952-14.118 3.175-18.281a10.615 10.615 0 0115.078 14.945z"
        fill="#FF6584"
      />
      <Path
        d="M116.681 59.19a1.759 1.759 0 00-1.453-1.44l1.44-1.453 1.453 1.44-1.44 1.453z"
        fill="#FF6584"
      />
      <Path
        d="M115.982 56.996a2.247 2.247 0 001.462 1.438M116.397 58.095L102.712 71.9"
        stroke="#2F2E41"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <Path
        opacity={0.4}
        d="M135.262 48.438c1.044-1.054 1.179-2.613.301-3.483-.878-.87-2.436-.722-3.48.332-1.044 1.053-1.179 2.613-.301 3.483.878.87 2.436.721 3.48-.332z"
        fill="#fff"
      />
      <Path
        d="M122.027 40.92c-1.359 5.702-8.153 13.7-13.855 12.34-5.702-1.36-8.155-11.563-6.795-17.265a10.615 10.615 0 0120.65 4.925z"
        fill="#E4B200"
      />
      <Path
        d="M108.93 54.493a1.759 1.759 0 00-1.99-.474l.474-1.99 1.991.474-.475 1.99z"
        fill="#E40046"
      />
      <Path
        d="M107.192 52.983a2.252 2.252 0 001.996.467"
        stroke="#2F2E41"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <Path
        opacity={0.4}
        d="M119.21 35.646c.344-1.443-.352-2.845-1.554-3.132-1.203-.286-2.456.65-2.8 2.094-.344 1.443.351 2.845 1.554 3.131 1.202.287 2.456-.65 2.8-2.093z"
        fill="#fff"
      />
      <Path
        d="M108.141 53.702l-4.51 18.909"
        stroke="#2F2E41"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <G opacity={0.8}>
        <Path
          opacity={0.8}
          d="M58.82 90.92c-2.964 2.884-10.033 5.085-12.918 2.12-2.884-2.964-.492-9.97 2.473-12.855a7.487 7.487 0 0112.18 2.596 7.49 7.49 0 01-1.734 8.139z"
          fill="#2000E4"
        />
        <Path
          opacity={0.8}
          d="M45.888 94.061a1.24 1.24 0 00-1.006-1.034l1.034-1.007 1.007 1.035-1.035 1.006z"
          fill="#E40046"
        />
        <Path
          opacity={0.8}
          d="M45.424 92.505a1.587 1.587 0 001.013 1.032"
          stroke="#2F2E41"
          strokeWidth={2}
          strokeMiterlimit={10}
        />
        <Path
          opacity={0.4}
          d="M59.133 86.713c.75-.73.865-1.828.257-2.453-.608-.626-1.71-.54-2.46.19s-.864 1.827-.256 2.452 1.71.54 2.46-.19z"
          fill="#fff"
        />
      </G>
      <Path
        d="M90.993 30.132h2.083a5.152 5.152 0 015.151 5.152v7.234H85.842v-7.234a5.151 5.151 0 015.151-5.152z"
        fill="#2F2E41"
      />
      <Path
        d="M85.082 62.382l-1.563 3.286s-1.274 4.415.17 4.887c1.443.472 1.725-4.53 1.725-4.53l1.195-3.313-1.527-.33z"
        fill="#FFB9B9"
      />
      <Path
        opacity={0.1}
        d="M85.082 62.382l-1.563 3.286s-1.274 4.415.17 4.887c1.443.472 1.725-4.53 1.725-4.53l1.195-3.313-1.527-.33z"
        fill="#000"
      />
      <Path
        d="M85.378 57.238l-1.977 6.92 3.13 1.646v-8.236l-1.153-.33z"
        fill="#424C72"
      />
      <Path
        d="M90.732 38.87s-.165 2.636-.494 2.636c-.33 0-.989 3.13-.989 3.13l2.8 1.812 3.46-3.13-.988-2.47s-.495-.99-.33-1.977c.165-.989-3.46 0-3.46 0z"
        fill="#FFB9B9"
      />
      <Path
        opacity={0.1}
        d="M90.732 38.87s-.165 2.636-.494 2.636c-.33 0-.989 3.13-.989 3.13l2.8 1.812 3.46-3.13-.988-2.47s-.495-.99-.33-1.977c.165-.989-3.46 0-3.46 0z"
        fill="#000"
      />
      <Path
        d="M101.11 65.063l.329 3.624s1.153 4.448 2.636 4.119c1.483-.33-.824-4.778-.824-4.778l-.659-3.46-1.482.495zM94.026 100.81s.989 6.095.33 7.249c-.66 1.153.659 1.317.659 1.317l3.953-.988v-1.812s-1.318-5.93-1.318-6.26c0-.33-3.624.494-3.624.494z"
        fill="#FFB9B9"
      />
      <Path
        d="M85.955 73.465s1.153 11.86 2.965 15.65c1.812 3.788 3.46 14.166 4.283 14.331.823.165 7.083-.988 7.907-1.647.824-.659-5.6-16.638-5.6-16.803 0-.165-1.484-14.826-1.484-14.826l-1.976-3.295-6.095 6.59z"
        fill="#2F2E41"
      />
      <Path
        opacity={0.1}
        d="M85.955 73.465s1.153 11.86 2.965 15.65c1.812 3.788 3.46 14.166 4.283 14.331.823.165 7.083-.988 7.907-1.647.824-.659-5.6-16.638-5.6-16.803 0-.165-1.484-14.826-1.484-14.826l-1.976-3.295-6.095 6.59z"
        fill="#000"
      />
      <Path
        d="M95.51 107.729s-1.648-.824-1.978-.329l-1.318 1.976s-5.6 2.636-3.624 2.966c1.977.329 5.766.329 6.26 0 .494-.33 5.931-3.295 5.766-3.46-.165-.164-1.483-3.624-1.647-3.294-.165.329-2.471 2.8-3.46 2.141z"
        fill="#2F2E41"
      />
      <Path
        d="M67.834 93.727s-3.79 2.635-5.601 2.141c-1.812-.494 0 3.625 0 3.625l3.295 1.812.988-.824s3.46-4.613 4.942-4.777c1.483-.165-3.624-1.977-3.624-1.977z"
        fill="#FFB9B9"
      />
      <Path
        d="M84.966 63.58l.659 3.46L73.27 85.82s-7.413 7.413-6.754 8.236c.659.824 4.777 5.601 5.765 4.942.989-.659 23.887-25.369 23.722-28.663-.165-3.295-5.6-9.555-5.6-9.555l-5.437 2.471v.33zM63.056 97.022s1.483-1.648.66-1.813a24.596 24.596 0 00-2.801-.33c-.33 0-4.777-2.305-5.107-1.482-.33.824 1.977 5.107 3.295 5.601 1.318.495 6.095 3.954 6.095 3.954s2.471-2.142 2.142-2.636c-.33-.494-4.943-1.483-4.284-3.294z"
        fill="#2F2E41"
      />
      <Path
        d="M92.05 40.518a3.954 3.954 0 100-7.907 3.954 3.954 0 000 7.907z"
        fill="#FFB9B9"
      />
      <Path
        d="M92.873 42.495s-2.8.164-3.624-.33c-.824-.494-2.636 6.754-2.636 6.754l-1.153 9.555s-.164 1.153 0 1.812c.165.659-1.647-.33-.988 1.483.659 1.812-.494 2.635.659 2.8 1.153.165 7.248-2.306 7.248-2.306l2.8-14.662.824-5.93-3.13.824z"
        fill="#D0CDE1"
      />
      <Path
        d="M90.437 41.156s-1.517-.309-2.011.02c-.495.33-2.307 2.801-2.307 3.46 0 .66-.659 7.907-.659 8.566 0 .66-.494 4.119-.494 4.448 0 .33.423 1.746.423 1.746l1.06-1.91s-.33-2.472.823-6.425c1.153-3.954 3.165-9.905 3.165-9.905zM92.05 43.648s2.2-3.46 2.335-3.13c.135.33 2.606.824 2.606.824s4.448 3.13 4.119 4.447c-.33 1.318-2.636 11.202-2.636 11.202s-2.141 5.107-.494 8.731c1.647 3.624-.33 4.942-.33 4.942s-1.317.659-.988 1.318c.33.659-3.789 3.13-4.283 1.318-.494-1.812-6.59-12.685-5.272-16.638 1.318-3.954 4.942-13.014 4.942-13.014z"
        fill="#424C72"
      />
      <Path
        d="M100.286 45.295s1.812 3.46 1.483 3.954c-.329.494 1.153 3.46 1.153 3.46a1.147 1.147 0 000 .823c.165.494 1.153 2.636 1.153 3.46 0 .823-.164 3.459 0 4.612.165 1.153 2.307 3.953.494 4.118-1.812.165-4.777 1.647-4.612 0 .165-1.647.659-5.6 0-6.26-.659-.659-1.153-.659-.824-1.482.33-.824-1.482-2.966-1.482-2.966l2.635-9.719z"
        fill="#424C72"
      />
      <Path
        d="M95.353 35.59H89.1l-1.416-3.254h8.731l-1.062 3.254z"
        fill="#2F2E41"
      />
      <Path
        d="M88.28 37.971c.167-.048.197-.449.068-.894s-.369-.767-.536-.719c-.167.049-.198.449-.069.894.13.446.37.767.537.72zM96.22 37.252c.13-.445.099-.846-.068-.894-.167-.048-.407.274-.537.719-.128.445-.098.846.07.894.166.049.406-.273.535-.719z"
        fill="#FFB9B9"
      />
      <Path
        d="M133.173 99.922c0 3.826-2.275 5.162-5.08 5.162l-.195-.002a8.055 8.055 0 01-.386-.018c-2.533-.179-4.5-1.584-4.5-5.142 0-3.682 4.704-8.328 5.059-8.674h.001l.021-.02s5.08 4.867 5.08 8.694z"
        fill="#F2F2F2"
      />
      <Path
        d="M127.907 104.499l1.858-2.596-1.862 2.881-.005.298a8.055 8.055 0 01-.386-.018l.2-3.827-.002-.03.004-.006.019-.362-1.868-2.888 1.873 2.617.005.077.151-2.892-1.598-2.985 1.618 2.476.157-5.996.001-.02v.02l-.026 4.728 1.591-1.874-1.598 2.281-.042 2.59 1.486-2.485-1.492 2.866-.024 1.44 2.158-3.459-2.166 3.961-.052 3.203z"
        fill="#3F3D56"
      />
      <Path
        opacity={0.05}
        d="M43.707 9.968L14.655 26.74l13.993 24.235 29.051-16.773L43.707 9.968z"
        fill="#000"
      />
      <Path
        d="M36.828 61.828v-.207c-.41 0-.826-.008-1.237-.025l-.008.206c.414.017.832.025 1.245.026zm1.244-.024c.412-.016.83-.041 1.242-.074l-.016-.205c-.41.032-.825.057-1.234.073l.008.206zm-3.731-.076l.016-.206a30.516 30.516 0 01-1.23-.123l-.025.204c.41.05.827.092 1.239.125zm6.212-.12c.411-.05.826-.108 1.233-.173l-.033-.204c-.404.065-.816.123-1.224.172l.024.205zm-8.683-.179l.033-.203c-.404-.065-.813-.14-1.216-.222l-.042.202c.406.082.818.158 1.225.223zm11.14-.216c.406-.082.815-.174 1.215-.272l-.049-.2a30.51 30.51 0 01-1.206.27l.04.202zm-13.579-.28l.05-.2c-.4-.098-.802-.206-1.195-.32l-.057.198c.396.115.8.223 1.202.322zm15.997-.312c.397-.115.797-.24 1.189-.37l-.065-.195c-.39.13-.786.253-1.181.367l.057.198zm-18.388-.38l.066-.196c-.39-.13-.781-.27-1.165-.416l-.073.193c.386.147.78.288 1.172.418zm20.753-.408a30.92 30.92 0 001.157-.465l-.08-.19c-.38.161-.766.317-1.15.462l.073.193zm-23.076-.475l.08-.19a30.76 30.76 0 01-1.124-.507l-.088.186c.371.177.752.349 1.132.51zm25.37-.502c.375-.178.75-.366 1.116-.558l-.096-.182c-.363.19-.736.377-1.108.553l.089.187zm-27.613-.565l.096-.182a30.91 30.91 0 01-1.08-.596l-.104.178c.357.206.723.408 1.088.6zm29.82-.595c.36-.208.719-.425 1.067-.646l-.11-.174c-.346.22-.703.435-1.06.642l.104.178zm-31.971-.65l.11-.173a30.803 30.803 0 01-1.03-.682l-.117.17c.34.235.69.466 1.037.686zm34.077-.683c.341-.236.68-.48 1.01-.729l-.123-.165c-.328.247-.666.49-1.004.724l.117.17zm-36.122-.73l.124-.165a31.055 31.055 0 01-.973-.762l-.13.16c.32.261.65.52.979.767zm38.113-.768c.32-.261.639-.532.948-.807l-.137-.154c-.307.272-.624.542-.942.802l.13.16zm-40.04-.806l.137-.154a31.168 31.168 0 01-.909-.839l-.142.15c.298.285.605.569.914.843zm41.903-.845c.297-.285.594-.581.88-.88l-.148-.143c-.285.297-.58.591-.875.875l.143.148zm-43.698-.879l.149-.143a30.744 30.744 0 01-.84-.908l-.153.137c.274.309.558.617.844.914zm45.423-.915c.275-.31.546-.628.807-.947l-.16-.13a30.49 30.49 0 01-.801.94l.154.137zm-47.075-.947l.16-.13c-.26-.319-.518-.646-.764-.974l-.165.124c.248.33.507.66.77.98zm48.65-.978c.248-.33.493-.67.728-1.008l-.17-.118c-.233.337-.476.674-.723 1.002l.165.124zm-50.148-1.012l.17-.117a31.359 31.359 0 01-.684-1.032l-.174.11c.22.349.452.698.688 1.04zm51.563-1.033c.22-.348.438-.705.644-1.063l-.178-.103c-.205.355-.42.71-.64 1.056l.174.11zM10.07 46.38l.179-.104a30.933 30.933 0 01-.599-1.084l-.182.096c.192.366.395.733.602 1.092zm54.144-1.08c.191-.364.379-.737.556-1.11l-.186-.088c-.176.37-.362.74-.553 1.103l.183.096zM8.91 44.173l.186-.088a30.706 30.706 0 01-.51-1.13l-.189.081c.163.381.335.764.513 1.137zm56.371-1.114c.163-.38.319-.767.465-1.151l-.192-.073c-.146.381-.301.766-.462 1.143l.19.08zm-57.35-1.18l.192-.073a30.985 30.985 0 01-.416-1.168l-.195.065c.13.392.272.788.419 1.176zm58.234-1.143c.131-.392.256-.792.371-1.188l-.198-.058c-.114.394-.238.791-.368 1.18l.195.066zM7.143 39.513l.198-.057a30.615 30.615 0 01-.32-1.194l-.2.049c.1.402.208.806.322 1.202zm59.717-1.169c.099-.401.19-.81.274-1.214l-.202-.041c-.082.401-.174.807-.272 1.206l.2.05zM6.55 37.096l.202-.04c-.082-.402-.156-.811-.222-1.217l-.203.033c.065.408.14.82.222 1.224zm60.808-1.19c.066-.407.125-.822.174-1.233l-.204-.025c-.05.409-.108.82-.174 1.225l.204.033zM6.153 34.639l.205-.025a30.75 30.75 0 01-.123-1.23l-.205.017c.032.41.074.827.123 1.238zm61.504-1.204c.034-.412.059-.83.076-1.242l-.206-.009c-.017.41-.042.826-.075 1.234l.205.017zM5.956 32.158l.206-.008c-.016-.41-.025-.826-.025-1.236v-.068h-.206v.067c0 .413.008.832.025 1.245zm61.597-1.21h.206v-.035c0-.402-.008-.809-.023-1.21l-.206.009c.015.398.023.802.023 1.202v.034zM6.165 29.61c.017-.41.042-.825.076-1.235l-.206-.016c-.034.412-.06.83-.076 1.242l.206.009zm61.292-1.133l.206-.016c-.032-.412-.074-.83-.122-1.238l-.205.024c.048.407.09.82.121 1.23zm-61.09-1.332c.049-.406.108-.818.174-1.223l-.204-.034c-.066.409-.125.823-.175 1.233l.204.024zm60.798-1.122l.204-.033c-.066-.408-.14-.82-.222-1.225l-.202.04c.081.403.155.812.22 1.218zm-60.4-1.317c.083-.403.175-.809.273-1.206l-.2-.05c-.099.4-.191.809-.275 1.214l.202.042zm59.911-1.107l.2-.049a30.834 30.834 0 00-.32-1.203l-.198.057c.114.395.22.797.318 1.195zM7.36 22.306c.115-.393.24-.79.37-1.18l-.196-.065c-.131.392-.256.791-.372 1.188l.198.057zm58.632-1.083l.196-.065c-.13-.392-.271-.788-.418-1.176l-.192.073c.145.385.285.778.414 1.168zm-57.844-1.26c.146-.384.302-.768.463-1.143l-.19-.081c-.162.377-.319.764-.466 1.15l.193.074zm56.968-1.058l.19-.08c-.163-.382-.335-.764-.512-1.139l-.186.089c.176.371.347.752.508 1.13zM9.12 17.696c.176-.37.362-.74.554-1.102l-.183-.096c-.192.364-.38.737-.557 1.11l.186.088zm54.935-1.03l.182-.095a31.068 31.068 0 00-.601-1.092l-.179.103c.206.356.407.72.598 1.084zm-53.783-1.152c.206-.354.422-.71.641-1.055l-.174-.11a31.21 31.21 0 00-.645 1.062l.178.103zm52.544-.992l.175-.11c-.221-.35-.453-.7-.687-1.04l-.17.118c.233.338.463.685.682 1.032zm-51.22-1.091c.235-.337.478-.674.725-1.001l-.164-.124a31.1 31.1 0 00-.73 1.007l.17.117zm49.815-.945l.164-.124c-.248-.33-.506-.66-.768-.98l-.16.13c.26.318.517.645.764.974zm-48.326-1.027c.26-.317.53-.633.803-.94l-.154-.137c-.275.309-.546.627-.808.946l.16.13zm46.762-.89l.154-.137c-.274-.309-.557-.617-.844-.915l-.148.143c.284.296.566.602.838.91zm-45.12-.957c.286-.296.58-.59.876-.874l-.143-.148c-.297.285-.594.58-.88.879l.147.143zm43.408-.827l.143-.149c-.297-.286-.605-.57-.914-.845l-.137.154c.307.273.613.555.908.84zM16.513 7.9c.308-.272.625-.542.943-.8l-.13-.16c-.32.26-.64.531-.95.806l.137.154zm39.774-.758l.13-.159c-.32-.262-.648-.52-.977-.769l-.125.165c.327.246.654.503.972.763zM18.43 6.338c.33-.247.667-.49 1.005-.723l-.117-.17c-.34.235-.68.48-1.011.728l.123.165zm35.884-.682l.118-.17c-.34-.235-.689-.466-1.036-.687l-.11.174c.345.22.69.45 1.028.683zm-33.846-.723c.347-.22.704-.435 1.06-.64l-.103-.178c-.358.206-.717.423-1.067.644l.11.174zm31.762-.6l.103-.179c-.356-.207-.722-.41-1.087-.602l-.096.183c.363.19.726.392 1.08.597zm-29.617-.637c.364-.19.736-.376 1.108-.552l-.088-.186c-.374.177-.75.364-1.116.556l.096.182zm27.434-.515l.089-.186c-.372-.177-.752-.35-1.131-.512l-.082.19c.377.161.755.332 1.124.508zm-25.195-.545c.378-.16.765-.316 1.15-.46l-.073-.194a30.81 30.81 0 00-1.158.465l.08.19zM47.78 2.21l.074-.192c-.386-.147-.78-.288-1.172-.42l-.066.195c.39.131.781.271 1.164.417zm-20.61-.449c.39-.13.787-.252 1.182-.365l-.057-.198c-.397.114-.797.237-1.19.367l.066.196zm18.266-.337l.058-.198c-.396-.115-.8-.224-1.202-.323l-.05.2c.399.099.8.207 1.194.321zm-15.89-.345c.399-.097.805-.188 1.208-.269l-.041-.202c-.406.082-.815.173-1.215.27l.049.2zM43.037.83l.042-.202a31.035 31.035 0 00-1.224-.225l-.034.203c.406.066.815.141 1.216.224zM31.97.59c.406-.065.818-.122 1.225-.17l-.024-.205c-.41.049-.825.106-1.233.171l.032.204zm8.627-.158l.024-.205c-.41-.05-.826-.092-1.238-.125l-.017.205c.41.033.823.075 1.23.125zM34.425.3A31.09 31.09 0 0135.66.229l-.008-.206c-.413.015-.831.04-1.242.072l.016.205zm3.707-.067l.009-.206A31.62 31.62 0 0036.896 0v.206c.41 0 .827.01 1.236.027z"
        fill="#3F3D56"
      />
      <Path
        d="M56.239 7.163a1.959 1.959 0 103.918 0 1.959 1.959 0 00-3.918 0z"
        fill="#CFCCE0"
      />
      <Path
        d="M55.62 6.236a1.959 1.959 0 103.918 0 1.959 1.959 0 00-3.917 0z"
        fill="#E40046"
      />
      <Path
        d="M55.62 6.275c0 .056.002.112.007.167l2.982-.412-2.981.058a2.295 2.295 0 00-.007.187zM56.342 7.266l2.68.31a1.87 1.87 0 00.205-.262l-2.885-.048z"
        fill="#3F3D56"
      />
      <Path
        d="M7.192 27.646a1.958 1.958 0 11-3.917 0 1.958 1.958 0 013.917 0z"
        fill="#CFCCE0"
      />
      <Path
        d="M7.81 26.719a1.958 1.958 0 11-3.916 0 1.958 1.958 0 013.916 0z"
        fill="#E40046"
      />
      <Path
        d="M7.81 26.758c0 .057-.002.112-.006.167l-2.982-.412 2.98.059c.006.061.008.123.008.186zM7.089 27.75l-2.681.309a1.862 1.862 0 01-.205-.262l2.886-.047zM6.367 25.585l-2.267.207c.043-.063.092-.122.147-.179l2.12-.027zM57.063 5.102l2.267.206a1.392 1.392 0 00-.147-.178l-2.12-.028z"
        fill="#3F3D56"
      />
      <Path
        d="M34.265 30.81c.306.045.624.073.917-.034.046-.017.097-.052.092-.104a.134.134 0 00-.02-.053 3.371 3.371 0 01-.277-.595.052.052 0 00-.017-.027.039.039 0 00-.03 0c-.135.04-.252.139-.386.18a.489.489 0 01-.21.019c-.062-.008-.145-.065-.2-.058.031.228.108.44.131.672zM39.934 30.28c.228-.133.465-.271.6-.475a.074.074 0 00.017-.04.077.077 0 00-.02-.04 1.786 1.786 0 00-.488-.444c-.101.06-.193.132-.272.212-.058.05-.217.132-.218.21 0 .044.06.095.089.132.038.047.074.095.108.145.02.024.202.29.184.3z"
        fill="#6C63FF"
      />
      <Path
        d="M35.557 31.386a.189.189 0 01-.037.127.185.185 0 01-.078.044c-.428.146-.925-.036-1.353.108-.088.03-.17.072-.26.1-.105.03-.213.048-.323.054a7.141 7.141 0 01-.455.027 1.151 1.151 0 01-.344-.029.42.42 0 01-.263-.198.182.182 0 01-.013-.141.151.151 0 01.028-.044.402.402 0 01.101-.078l.158-.096c.074-.05.154-.09.24-.12.062-.02.128-.029.191-.045.222-.061.391-.228.548-.389l.215-.217a.214.214 0 01.075-.057.216.216 0 01.092-.008c.209.014.41.078.585.186.045.032.093.06.145.081.126.047.287.012.403-.047.055-.028.043-.044.066-.094.023-.05.08-.082.129-.037a.127.127 0 01.03.055c.047.145.029.301.029.453a.19.19 0 00.01.07.397.397 0 00.041.066.426.426 0 01.04.229z"
        fill="#514E7F"
      />
      <Path
        d="M35.557 31.36a.206.206 0 01-.037.135.182.182 0 01-.078.046c-.429.154-.925-.038-1.353.114-.088.03-.171.076-.26.105a1.413 1.413 0 01-.323.058 6.855 6.855 0 01-.455.027 1.093 1.093 0 01-.344-.03.413.413 0 01-.263-.209.2.2 0 01-.013-.148.162.162 0 01.028-.047c.025.053.043.122.06.147a.3.3 0 00.2.145.496.496 0 00.185-.023c.388-.097.801-.098 1.175-.244.128-.05.25-.118.385-.148.134-.03.277-.023.416-.034.22-.018.431-.084.648-.119a.471.471 0 01.029.225z"
        fill="#464353"
      />
      <Path
        d="M40.832 30.288c-.019.16-.115.296-.222.412-.106.115-.226.22-.31.353-.105.165-.152.37-.287.51a.784.784 0 01-.174.129c-.07.043-.145.079-.223.107-.202.067-.42.051-.632.035a.55.55 0 01-.2-.04.606.606 0 01-.083-.053.405.405 0 01-.13-.135.14.14 0 01-.013-.099.232.232 0 01.06-.095c.048-.052.099-.1.153-.143a.93.93 0 00.199-.18.598.598 0 00.077-.18c.03-.113.05-.229.056-.346 0-.077.007-.155.023-.23.032-.12.117-.226.107-.349a.09.09 0 01.005-.053.07.07 0 01.04-.025.683.683 0 01.207-.05.235.235 0 01.192.078c.03.037.05.09.093.105a.143.143 0 00.066.002c.107-.01.22-.025.303-.097a.39.39 0 00.126-.287c0-.04-.017-.084.044-.09.046-.006.082.045.106.077.084.117.171.24.203.384a.107.107 0 01.038-.008.17.17 0 01.139.073.296.296 0 01.037.195z"
        fill="#514E7F"
      />
      <Path
        d="M40.832 30.272c-.019.16-.116.299-.224.416-.107.117-.228.222-.313.357-.105.167-.152.374-.288.515a.797.797 0 01-.175.13c-.071.044-.147.08-.225.108-.204.068-.423.052-.636.036a.552.552 0 01-.202-.04.607.607 0 01-.084-.054.41.41 0 01-.13-.137.31.31 0 01.13-.033c.095.006.164.099.254.127.13.04.258-.054.388-.086.086-.021.175-.016.26-.046a.634.634 0 00.191-.12.995.995 0 00.205-.207 1.34 1.34 0 00.12-.25c.07-.168.15-.33.243-.484a.339.339 0 01.05-.068c.02-.02.043-.033.067-.05.087-.07.123-.183.154-.294a.532.532 0 01.034-.098.17.17 0 01.14.074c.037.06.052.133.041.204z"
        fill="#464353"
      />
      <Path
        d="M43.688 24.223v-.586c0-.432-.164-.846-.456-1.151a1.521 1.521 0 00-1.1-.477H20.004c-.413 0-.808.171-1.1.477-.292.305-.456.72-.456 1.15v1.082l25.24-.495z"
        fill="#33323D"
      />
      <Path
        d="M26.15 21.442s-.063 3.911.63 5.198c.694 1.287.991 6.885.991 6.885s7.27.752 12.335-.9c5.066-1.653 15.845-2.329 15.845-2.329l-1.817-12.242s-8.973-.576-14.078 1.859c-5.105 2.434-13.906 1.529-13.906 1.529z"
        fill="#D97AAD"
      />
      <Path
        d="M27.76 22.87s-.228 3.228.342 4.259c.571 1.031.598 5.634.598 5.634s6.542.304 11.195-1.28c4.654-1.584 14.433-2.612 14.433-2.612L53.217 18.86s-8.092-.083-12.814 2.147c-4.723 2.23-12.644 1.865-12.644 1.865z"
        fill="#F0ACD1"
      />
      <Path
        opacity={0.1}
        d="M40.331 29.65c.93-.116 1.484-1.828 1.235-3.825-.248-1.996-1.205-3.52-2.135-3.405-.931.116-1.484 1.828-1.236 3.825.249 1.996 1.205 3.52 2.136 3.405z"
        fill="#000"
      />
      <Path
        opacity={0.2}
        d="M49.223 12.045s-8.718 2.206-12.83 6.09c-4.11 3.883-12.765 5.722-12.765 5.722s1.14 3.742 2.195 4.754c1.054 1.012 3.055 6.25 3.055 6.25s7.149-1.516 11.462-4.644c4.314-3.129 14.367-7.08 14.367-7.08l-5.484-11.092z"
        fill="#000"
      />
      <Path
        d="M23.497 23.297s1.14 3.742 2.193 4.754c1.054 1.013 3.055 6.25 3.055 6.25s7.15-1.515 11.464-4.644c4.314-3.128 14.367-7.078 14.367-7.078L49.09 11.485s-8.717 2.206-12.828 6.09c-4.111 3.884-12.766 5.722-12.766 5.722z"
        fill="#D97AAD"
      />
      <Path
        d="M25.435 24.114s.774 3.142 1.634 3.947c.86.806 2.296 5.179 2.296 5.179s6.32-1.72 10.263-4.655c3.943-2.936 12.936-6.91 12.936-6.91l-4.13-9.192s-7.726 2.403-11.537 5.975c-3.81 3.572-11.462 5.656-11.462 5.656z"
        fill="#F0ACD1"
      />
      <Path
        opacity={0.1}
        d="M39.512 26.758c.85-.396.85-2.196.002-4.02-.85-1.823-2.228-2.981-3.078-2.585-.85.396-.851 2.196-.002 4.02.85 1.823 2.227 2.98 3.078 2.585z"
        fill="#000"
      />
      <Path
        opacity={0.1}
        d="M44.258 24.724v15.613a1.355 1.355 0 01-.83 1.248 1.339 1.339 0 01-.515.102h-23.12c-.357 0-.7-.142-.951-.395a1.352 1.352 0 01-.394-.955V23.15c.663.247.663.247 1.344.226h23.121c.356 0 .698.142.95.395.252.252.394.595.395.953z"
        fill="#000"
      />
      <Path
        d="M44.258 24.997V40.49c0 .356-.142.696-.394.947a1.347 1.347 0 01-.95.393H19.791c-.356 0-.698-.142-.95-.393a1.337 1.337 0 01-.394-.947V23.435c.663.245.663.245 1.344.225h23.121a1.338 1.338 0 011.345 1.338z"
        fill="#504F60"
      />
      <Path
        opacity={0.1}
        d="M44.115 30.707v4.991H39.39a2.41 2.41 0 01-1.701-.742 2.527 2.527 0 01-.702-1.753c0-.656.252-1.286.702-1.753a2.41 2.41 0 011.701-.742h4.726z"
        fill="#000"
      />
      <Path
        d="M44.258 30.565v4.99h-4.82a2.48 2.48 0 01-1.736-.742 2.5 2.5 0 010-3.505 2.48 2.48 0 011.736-.742l4.82-.001z"
        fill="#33323D"
      />
      <Path
        opacity={0.1}
        d="M39.624 34.13c.512 0 .927-.447.927-.998 0-.552-.415-.999-.927-.999s-.927.447-.927.998c0 .552.415.999.927.999z"
        fill="#000"
      />
      <Path
        d="M39.766 34.015c.512 0 .927-.447.927-.998 0-.551-.415-.998-.927-.998s-.927.447-.927.998c0 .551.415.998.927.998z"
        fill="#E40046"
      />
      <Path
        d="M10.162 48.18c.046-.664-.933-1.273-2.186-1.36-1.253-.087-2.307.38-2.353 1.044-.046.663.932 1.272 2.186 1.359 1.253.087 2.307-.38 2.353-1.044z"
        fill="#F0ACD1"
      />
      <Path
        d="M16.122 52.83C11.214 50.553 6.173 50.198 1 51.767l.43-6.243a25.987 25.987 0 0115.122 1.063l-.43 6.243z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M14.34 51.313c-3.59-1.627-7.279-1.88-11.064-.76l.315-4.459a19.451 19.451 0 0111.064.76l-.314 4.459z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M11 47.701c.046-.663-.932-1.272-2.186-1.36-1.253-.087-2.307.38-2.353 1.044-.046.664.933 1.272 2.186 1.36 1.254.087 2.307-.38 2.353-1.044z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M69.276 27.795c1.257 0 2.276-.594 2.276-1.327s-1.02-1.328-2.276-1.328c-1.257 0-2.276.595-2.276 1.328 0 .733 1.019 1.327 2.276 1.327z"
        fill="#F0ACD1"
      />
      <Path
        d="M78 30.83c-5.184-1.98-10.368-1.98-15.552 0v-6.426a26.635 26.635 0 0115.552 0v6.426z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M75.724 29.313c-3.666-1.386-7.333-1.386-11 0v-4.498a19.029 19.029 0 0111 0v4.498z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M70.034 27.037c1.257 0 2.276-.51 2.276-1.138 0-.629-1.019-1.138-2.276-1.138s-2.276.51-2.276 1.138c0 .628 1.02 1.138 2.276 1.138z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M18.088 8.336c1.23-.25 2.121-.983 1.988-1.635-.133-.651-1.239-.976-2.47-.725-1.23.252-2.121.984-1.988 1.635.133.652 1.239.977 2.47.725z"
        fill="#F0ACD1"
      />
      <Path
        d="M27.172 9.502c-5.405-.884-10.423.156-15.054 3.121l-1.256-6.249a26.25 26.25 0 0115.055-3.12l1.255 6.248z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M24.897 8.604c-3.897-.601-7.515.106-10.854 2.122l-.905-4.249A19.882 19.882 0 0123.99 4.355l.906 4.25z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M18.768 7.651c1.23-.25 2.12-.983 1.988-1.635-.133-.651-1.24-.976-2.47-.725-1.231.251-2.121.983-1.988 1.635s1.239.977 2.47.725z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
    </Svg>
  );
}

export default SvgComponent;
